<article class="poster-wrapper">
    <article class="poster-content">
        <section class="context">
            <span class="label">
                finzyFLEX
            </span>
            <span class="description">
                Introducing new level of flexibility….
            </span>
            <div class="features-wrapper">
                <span class="feature-text">
                    Choose Your Interest rate
                </span>
                <span class="feature-text">
                    Flexible Commitment Period
                </span>
                <span class="feature-text">
                    Customized Cashflow
                </span>
            </div>
            <button class="primary-btn" [routerLink]="['/lenderintro']" (click)="analyticsTracker.trackButtonClick('Investor Home', 'Invest Now', 'Banner')">
                Invest Now
            </button>
        </section>
        <section class="chart">
            <embed src="../../../../../assets/gif/finzy-flex/landing-page-animation.html" alt="flex-chart" class="chart-img">
        </section>
    </article>
</article>